'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const RocketIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M7.2 11.5L5 9.30002L5.7 8.60002C6.9 7.40002 8.8 7.40002 10 8.60002M12.5 16.9L14.7 19.1L15.4 18.4C16.6 17.2 16.6 15.3 15.4 14.1M6.8 13.6C5.8 14.6 5.8 16.2 6.8 17.2C7.8 18.2 9.4 18.2 10.4 17.2M19.9 4.10002C16.9 3.60002 13.7 4.60002 11.3 7.00002L7 11.3L12.7 17L17 12.7C19.4 10.3 20.4 7.10002 19.9 4.10002ZM15.8 8.30002C15.3 7.80002 14.5 7.80002 14 8.30002C13.5 8.80002 13.5 9.60002 14 10.1C14.5 10.6 15.3 10.6 15.8 10.1C16.3 9.60002 16.3 8.80002 15.8 8.30002Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpRocketIcon = forwardRef(RocketIcon);

export { VpRocketIcon as default };
